import React from 'react';
  
  const Terms = ({
    isMobile,
  }) =>  {
    return (
      <div style={{padding: '1.5rem', background: 'rgb(39,39,42,.3)', border: '1px solid rgb(39,39,42)', borderRadius: '.75rem'}}>
        <h2 style={{color: 'rgb(228,228,231)', fontWeight: '600', fontSize: '1.5rem', margin: 0}}>
            Terms of Service
        </h2>
        <p style={{color: 'rgb(212,212,216)', fontSize: '.875rem', lineHeight: '1.25rem', marginTop: '.5rem'}}>
            By using Interview Cheater, you agree to these terms of service:
        </p>
        <div style={{margin: '1rem 0'}}>
            {/* Bulleted List Item */}
            <div style={{display: 'flex', alignItems: 'center', gap: '.75rem', marginTop: '.25rem'}}>
                {/* Bullet point */}
                <div style={{background: '#e5e7eb', borderRadius: '50%', width: '1.375rem', height: '.375rem', margin: '10px 0 auto'}}></div>
                {/* Text */}
                <p style={{color: 'rgb(212,212,216)', fontSize: '.875rem', lineHeight: '1.25rem', margin: '0'}}>
                    <b>License:</b> We grant you a limited, non-exclusive, non-transferable license to use Interview Cheater for your personal coding interview preparation. This tool is NOT intended to be used in a real interview. The purpose of the tool is purely illustrative and all of our marketing efforts are for the purpose of showing big tech companies how easy it would be to game their broken interview processes.
                </p>
            </div>
            {/* Bulleted List Item */}
            <div style={{display: 'flex', alignItems: 'center', gap: '.75rem', margin: '.75rem 0'}}>
                {/* Bullet point */}
                <div style={{background: '#e5e7eb', borderRadius: '50%', width: '.375rem', height: '.375rem'}}></div>
                {/* Text */}
                <p style={{color: 'rgb(212,212,216)', fontSize: '.875rem', lineHeight: '1.25rem', margin: '0'}}>
                    <b>User Conduct:</b> You agree not to:
                </p>
            </div>
            <div style={{margin: '1rem 1.125rem'}}>
                {/* Bulleted List Item */}
                <div style={{display: 'flex', alignItems: 'center', gap: '.75rem', marginTop: '.25rem'}}>
                    {/* Bullet point */}
                    <div style={{background: '#e5e7eb', borderRadius: '50%', width: '.375rem', height: '.375rem'}}></div>
                    {/* Text */}
                    <p style={{color: 'rgb(212,212,216)', fontSize: '.875rem', lineHeight: '1.25rem', margin: '0'}}>
                        Share your account credentials with others
                    </p>
                </div>
                {/* Bulleted List Item */}
                <div style={{display: 'flex', alignItems: 'center', gap: '.75rem', margin: '.75rem 0'}}>
                    {/* Bullet point */}
                    <div style={{background: '#e5e7eb', borderRadius: '50%', width: '.375rem', height: '.375rem'}}></div>
                    {/* Text */}
                    <p style={{color: 'rgb(212,212,216)', fontSize: '.875rem', lineHeight: '1.25rem', margin: '0'}}>
                        Attempt to reverse engineer the software
                    </p>
                </div>
                {/* Bulleted List Item */}
                <div style={{display: 'flex', alignItems: 'center', gap: '.75rem', margin: '.75rem 0'}}>
                    {/* Bullet point */}
                    <div style={{background: '#e5e7eb', borderRadius: '50%', width: '.375rem', height: '.375rem'}}></div>
                    {/* Text */}
                    <p style={{color: 'rgb(212,212,216)', fontSize: '.875rem', lineHeight: '1.25rem', margin: '0'}}>
                        Use the service for any illegal purposes
                    </p>
                </div>
                {/* Bulleted List Item */}
                <div style={{display: 'flex', alignItems: 'center', gap: '.75rem', margin: '.75rem 0'}}>
                    {/* Bullet point */}
                    <div style={{background: '#e5e7eb', borderRadius: '50%', width: '.375rem', height: '.375rem'}}></div>
                    {/* Text */}
                    <p style={{color: 'rgb(212,212,216)', fontSize: '.875rem', lineHeight: '1.25rem', margin: '0'}}>
                        Interfere with or disrupt the service
                    </p>
                </div>
            </div>
            {/* Bulleted List Item */}
            <div style={{display: 'flex', alignItems: 'center', gap: '.75rem', margin: '.75rem 0'}}>
                {/* Bullet point */}
                <div style={{background: '#e5e7eb', borderRadius: '50%', width: '.6rem', height: '.375rem', margin: '10px 0 auto'}}></div>
                {/* Text */}
                <p style={{color: 'rgb(212,212,216)', fontSize: '.875rem', lineHeight: '1.25rem', margin: '0'}}>
                    <b>Content Rights:</b> All content generated using our service is owned by you, but the software, branding, and infrastructure remain our intellectual property.
                </p>
            </div>
            {/* Bulleted List Item */}
            <div style={{display: 'flex', alignItems: 'center', gap: '.75rem', marginTop: '.25rem'}}>
                {/* Bullet point */}
                <div style={{background: '#e5e7eb', borderRadius: '50%', width: '.5rem', height: '.375rem', margin: '10px 0 auto'}}></div>
                {/* Text */}
                <p style={{color: 'rgb(212,212,216)', fontSize: '.875rem', lineHeight: '1.25rem', margin: '0'}}>
                    <b>Service Changes:</b> We reserve the right to modify, suspend, or discontinue any part of the service with reasonable notice.
                </p>
            </div>
            {/* Bulleted List Item */}
            <div style={{display: 'flex', alignItems: 'center', gap: '.75rem', marginTop: '.25rem'}}>
                {/* Bullet point */}
                <div style={{background: '#e5e7eb', borderRadius: '50%', width: '.375rem', height: '.375rem'}}></div>
                {/* Text */}
                <p style={{color: 'rgb(212,212,216)', fontSize: '.875rem', lineHeight: '1.25rem', margin: '0'}}>
                    <b>Liability:</b> The service is provided "as is" without warranties of any kind, either express or implied.
                </p>
            </div>
        </div>
        {/* Text */}
        <p style={{color: 'rgb(212,212,216)', fontSize: '.875rem', lineHeight: '1.25rem', margin: '0'}}>
            These terms may be updated periodically. Continued use of the service constitutes acceptance of any changes.
        </p>
    </div>
    );
  }
  
  export default Terms;
  